var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Поворот на 90 градусов
export function rotateData(data, size) {
    var newData = [];
    var start = (size - 1) * size;
    for (var j = 0; j < size; j++) {
        for (var i = 0; i < size; i++) {
            var index = start + j - size * i;
            if (data[index]) {
                var item = data[index];
                newData.push(__assign({}, item));
            }
            else {
                newData.push({ value: 0 });
            }
        }
    }
    return newData;
}
